module.exports = __webpack_public_path__ + "img/6.2ba9668a.jpg";